/**
 * Finshop REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EventRequest { 
    /**
     * Код подтверждения
     */
    confirmationData?: string;
    /**
     *     Идентификатор Event:     * `APPLICATION_OFFER_WHY_SUCH` - Почему такие условия?     * `APPLICATION_CONSULTATION` - Заказать консультацию по оформлению заявки     * `CONTRACT_CONSULTATION` - Заказать консультацию по оформлению договора 
     */
    eventId: EventRequest.EventIdEnum;
    /**
     * Дополнительные атрибуты (например applicationId, contractId)
     */
    params?: { [key: string]: string; };
}
export namespace EventRequest {
    export type EventIdEnum = 'APPLICATION_OFFER_WHY_SUCH' | 'APPLICATION_CONSULTATION' | 'CONTRACT_CONSULTATION';
    export const EventIdEnum = {
        ApplicationOfferWhySuch: 'APPLICATION_OFFER_WHY_SUCH' as EventIdEnum,
        ApplicationConsultation: 'APPLICATION_CONSULTATION' as EventIdEnum,
        ContractConsultation: 'CONTRACT_CONSULTATION' as EventIdEnum
    };
}


